import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@mui/utils';
import { Box, Checkbox, TableRow, TableCell, TableHead, TableSortLabel } from '@mui/material';

// ----------------------------------------------------------------------

ListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func
};

export default function ListHead({
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected,
  onRequestSort,
  onSelectAllClick
}) {
  // const createSortHandler = (property) => (event) => {
  //   onRequestSort && onRequestSort(event, property);
  // };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
          />
        </TableCell> */}
        {headLabel.map((headCell) => {
          // 处理标题换行：仅 / 符号换行，| 符号不换行
          const renderLabel = () => {
            const label = headCell.label || '';
            // 如果包含 /，则分割并换行显示
            if (label.includes('/')) {
              const parts = label.split('/');
              return (
                <>
                  {parts.map((part, index) => (
                    <div key={index} style={{ lineHeight: '1.2' }}>
                      {part.trim()}
                    </div>
                  ))}
                </>
              );
            }
            return label;
          };

          return (
            <TableCell
              key={headCell.id}
              align={headCell.alignRight ? 'right' : 'left'}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={e => {
                  onRequestSort && headCell.sortable && onRequestSort(headCell.id);
                }}
                hideSortIcon={!headCell.sortable}
              >
                {renderLabel()}
                {orderBy === headCell.id ? (
                  <Box sx={{ ...visuallyHidden }}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
